import { useState } from 'react';
import RadioSelect from '../RadioSelect/RadioSelect';
import xIcon from "../../icons/X.svg"
import { Link } from 'react-router-dom';
import { MainTracker } from '../../PixelTrackers/MainTracker';
import * as translator from '../../utils/translator'


type Props = {
  rootTitle: string;
  onClose: () => void;
  categories: {
    id: number;
    title: string;
    mention: string;
  }[];
  country: string;
  language: string;
};

const SubscriptionCategoryModal: React.FC<Props> = ({
    rootTitle,
    categories,
    onClose,
    country,
    language
  }) => {

    const [selectedCategoryMention, setSelectedCategoryMention] = useState<string>(categories[0].mention);
  
    return (

      <div 
        id="subscription-category-modal-container" 
        className='w-full md:w-[600px] bg-white relative'
        style={{ borderTopLeftRadius: '30px', borderTopRightRadius: '6px', borderBottomLeftRadius: '6px', borderBottomRightRadius: '30px' }}
      >
        {/* Header Section */}
        <div 
          id="subscription-category-modal-header" 
          className='p-8 pb-4'
        >
          {/* Modal title  */}
          <h2 id="subscription-category-modal-title" className='text-2xl font-bold text-[#1F2F4C] mb-0'>
            {translator.translate(language, "my_account", "myAccountSubscription/subscription_title_modal").replace(":rootTitle", rootTitle)}
          </h2>

          {/* Close button */}
          <img src={xIcon} alt="close" className='absolute top-4 right-6 cursor-pointer hover:opacity-90 ease-in-out transition-opacity duration-300' onClick={onClose} />
        </div>
        
        {/* Content Section */}
        <div id="subscription-category-modal-content" className="p-8 pt-2 ">

          {/* Instruction Text Section */}
          <p id="subscription-category-modal-instructions" className='text-[#787777] font-medium mb-6 font-roboto'>
            {translator.translate(language, "my_account", "myAccountSubscription/subscription_modal_description")}
          </p>
          
          {/* Category Selection Section */}
          <div id="subscription-category-modal-categories-container" className='mb-8'>
            <p id="subscription-category-modal-category-heading" className='text-[#98A0AF] text-xs font-medium mb-3'> {translator.translate(language, "my_account", "myAccountSubscription/category_selection_heading")} </p>
            
            <div id="subscription-category-modal-options" className='space-y-2.5'>
              {categories.map((category) => (
                <label 
                  key={category.id}
                  id={`subscription-category-option-${category.mention}`} 
                  className='flex items-center cursor-pointer'
                  onClick={() => setSelectedCategoryMention(category.mention)}
                >
                  <RadioSelect 
                    selected={selectedCategoryMention === category.mention}
                    disabled={false}
                    backgroundColor="#269C6E"
                  />
                  <span
                    id={`subscription-category-radio-${category.mention}-label`} 
                    className='text-[#656D79] text-sm font-medium'
                  >
                    {category.title}
                  </span>
                </label>
              ))}
            </div>
          </div>
          
          {/* Action Buttons Section */}
          <div id="subscription-modal-buttons" className='flex flex-col md:flex-row gap-2 md:gap-4'>

            {/* Request treatment button */}
            <Link 
              id="subscription-category-modal-request-btn"
              to={`/start-consultation/${country}/${language}/${selectedCategoryMention}`}
              onClick={() => MainTracker.track('custom', 'Decision on subscription promo my account', {'Decision': 'Request treatment', 'Chosen category': selectedCategoryMention})}
              className='flex-1 py-4 cursor-pointer bg-[#269C6E] text-center !no-underline text-white text-[14px] font-medium transition-opacity hover:opacity-90'
              style={{ borderRadius: '6px', border: '2px solid #269C6E'}}
            >
              {translator.translate(language, "my_account", "myAccountSubscription/request_treatment_button")}
            </Link>

            {/* Cancel button */}
            <button 
              id="subscription-category-modal-cancel-btn"
              className='flex-1 py-4 cursor-pointer border-gray-300  font-medium text-[14px] text-[#269C6E] bg-transparent transition-opacity hover:opacity-85'
              style={{ border: '2px solid #269C6E', accentColor:"transparent" }}
              onClick={onClose}
            >
              {translator.translate(language, "my_account", "myAccountSubscription/cancel_button")}
            </button>
          </div>
        </div>
      </div>
    );
  };


  export default SubscriptionCategoryModal